import { environment } from "./environments/environment";

export let gb = new window["growthbook"].GrowthBook({
  apiHost: environment.growthbookHostApi,
  clientKey: environment.growthbookClientKey,
  enableDevMode: true,
  subscribeToChanges: true,
  trackingCallback: (experiment, result) => {
    console.log("Viewed Experiment", {
      experimentId: experiment.key,
      variationId: result.key,
    });
  },
});

gb.loadFeatures();



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/1_SCE_CI_CD_SIT/src/growthbook.ts